var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShareKakao38 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 38"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FAE300",
  d: "M19.374 38c10.493 0 19-8.507 19-19s-8.507-19-19-19-19 8.507-19 19 8.507 19 19 19"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#391B1B",
  d: "M19.793 10.875c-4.738 0-8.579 3.036-8.579 6.782a6.63 6.63 0 0 0 4.07 5.77c-.179.67-.65 2.427-.744 2.8-.116.467.171.46.359.335.147-.1 2.351-1.6 3.3-2.242q.792.117 1.592.117c4.738 0 8.579-3.037 8.579-6.782s-3.841-6.782-8.579-6.782"
})));
export default SvgIconShareKakao38;